// Onthoudt dat de gebruiker vanuit het Account-tabblad een scherm (privacybeleid,
// algemene voorwaarden) opende, zodat de terugknop weer op het Account-tabblad
// uitkomt i.p.v. op het standaard-beginscherm van het dashboard.
const KEY = 'ss_return_to_profile';

export const markReturnToProfile = () => {
  try { sessionStorage.setItem(KEY, '1'); } catch (e) { /* ignore */ }
};

export const wantsReturnToProfile = () => {
  try { return sessionStorage.getItem(KEY) === '1'; } catch (e) { return false; }
};

export const clearReturnToProfile = () => {
  try { sessionStorage.removeItem(KEY); } catch (e) { /* ignore */ }
};
